var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
/**
 * # Capacity
 *
 * 작은 게이지를 만들때 쓰입니다.
 *
 * @param {CapacityProps} {@link CapacityProps} 기본적인 프롭
 *
 * @example ```tsx
  <Capacity value={10} />
  <Capacity value={20} />
  <Capacity value={30} />
  <Capacity value={40} />
  <Capacity value={50} />
  <Capacity value={60} />
  <Capacity value={70} />
  <Capacity value={80} />
  <Capacity value={90} />
  <Capacity value={100} />
 * ```
 */
export var Capacity = function (props) {
    var value = props.value, _a = props.limit, limit = _a === void 0 ? 100 : _a;
    return (<Container>
      <Progress percent={(value / limit) * 100}/>
    </Container>);
};
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 50px;\n  height: 10px;\n  border-radius: 4px;\n  ", "\n"], ["\n  width: 50px;\n  height: 10px;\n  border-radius: 4px;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    overflow: hidden;\n  "], ["\n    background: ", ";\n    overflow: hidden;\n  "])), theme.colors.PRIMARY.ACCENT_2);
});
var Progress = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 10px;\n  ", "\n"], ["\n  height: 10px;\n  ", "\n"])), function (_a) {
    var percent = _a.percent, theme = _a.theme;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: ", "px;\n    ", "\n    ", "\n    ", "\n  "], ["\n    width: ", "px;\n    ", "\n    ", "\n    ", "\n  "])), percent < 15 ? 7 : (percent / 100) * 50, percent <= 100 && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.colors.ERROR.DEFAULT), percent < 66 && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.colors.WARNING.DEFAULT), percent < 33 && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.colors.CYAN.LIGHT));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=index.jsx.map